import React from "react";
import { useState } from "react";
import { Box, Paper, Typography, IconButton, Grid } from "@mui/material";
import DeleteIcon from "@mui/icons-material/DeleteOutline";
import axios from "axios";
import Avatar from "@mui/material/Avatar";

const CommentList = ({
  comments,
  isAuthenticated,
  userId,
  authToken,
  refetchPlaceData,
}) => {
  const getApiBaseUrl = () => {
    // Always use production backend (onrender)
    return import.meta.env.VITE_ENVPROD || 'https://activitynavigator-backend.onrender.com';
  };
  const apiBaseUrl = getApiBaseUrl();
  const [commentText, setCommentText] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [response, setResponse] = useState(null);

  const handleDeleteComment = async (commentId) => {
    try {
      await axios.delete(
        `${apiBaseUrl}/api/users/${userId}/comments/${commentId}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      refetchPlaceData();
    } catch (error) {
      console.error("Error deleting comment:", error);
    }
  };

  return (
    <Grid container spacing={2}>
      {comments.map((comment) => (
        <Grid item xs={12} sm={6} md={6} lg={6} key={comment._id}>
          <Paper sx={{ p: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Avatar sx={{ mr: 1 }}>
                {comment.userId.first_name[0]}
                {comment.userId.last_name[0]}
              </Avatar>
              <Box>
                <Typography>
                  {comment.userId.first_name} {comment.userId.last_name}
                </Typography>
              </Box>
            </Box>
            <Typography sx={{ mt: 1 }} variant="caption">
              Date added: {comment.dateAdded}
            </Typography>
            <Typography sx={{ mt: 1 }}>{comment.comment}</Typography>
            {/* Delete button */}
            {isAuthenticated && comment.userId._id === userId && (
              <IconButton
                onClick={() => handleDeleteComment(comment._id)}
                sx={{ mt: 1 }}
              >
                <DeleteIcon />
              </IconButton>
            )}
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
};

export default CommentList;
